import { z } from 'zod';
import { reportDocumentSchema } from '../document';

export const reportDataItemSchema = z.object({
  name: z.string(),
  rows: z.array(z.record(z.union([z.string(), z.number()]))),
  total: z.record(z.number()),
});

export const reportingApiResponseSchema = z.object({
  data: z.array(reportDataItemSchema),
  document: reportDocumentSchema.optional(),
});

export type ReportingApiResponseDto = z.infer<typeof reportingApiResponseSchema>;

export interface ReportingApiHttpResponse {
  displayData: ReportingApiResponseDto['data'];
  document?: ReportingApiResponseDto['document'];
}
